import _ from 'lodash'
import moment from 'moment'
import React, {
  cloneElement,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  getValue,
  rerender,
} from '../../store/actions'
import BaseCheckbox from '../BaseCheckbox'
import DashedLink from '../DashedLink'
import DefaultLink from '../DefaultLink'
import IconEdit from '../icons/IconEdit'
import IconMinus from '../icons/IconMinus'
import IconPlus from '../icons/IconPlus'
import IconTrashCan from '../icons/IconTrashCan'
import ModalOrderInfo from '../ModalOrderInfo'
import StatusChanger from '../StatusChanger'
import VarianceTitle from '../VarianceBlock/VarianceTitle'


const FoldIndicator = ({ isOpen }) => {
  return (
    <span className="fold-indicator">
      {
        isOpen ?
          <IconMinus /> :
          <IconPlus />
      }
    </span>
  )
}
/**
 * Get checked row ids
 *
 * @param {Object} checkboxState
 *
 * @returns {string[]}
 *
 *
 */
const getCheckboxIds = (checkboxState) => {
  return Object.entries(checkboxState).map(([ checkboxId, enabled ]) => {
    return enabled ? checkboxId : null
  }).filter(Boolean)
}

const TableBody = ({
                     data,
                     options,
                     actions,
                     padding,
                     keyProp,
                     order,
                     show,
                     render,
                     value,
                     rerender,
                     countingMode,
                     checkedRows,
                     setCheckedRows
                   }) => {


  // const [ checkedRows, setCheckedRows ] = useState({})
  const [ filterType, setFilterType ] = useState('all')
  const [ open, setOpen ] = useState(false);
  const [ selectedRow, setSelectedRow ] = useState(null);

  useEffect(() => {
    setCheckedRows({})
  }, [ render ])

  const cellGenerator = useCallback((column, row, isOpen)=>{
    switch (column.type) {
      case 'checkbox':
        return <BaseCheckbox
            checkboxId={countingMode === 'Parts' ? row.partnum : row.binName}
            isChecked={checkedRows[row.partnum]}
            onCheck={() => checkboxOnClick(row)}
            key={`${row.UUID}-checkbox`}
            isDisabled={'active'}

        />
      case 'component':
        return cloneElement(column.component, { row, isOpen, actions: actions ? actions[column.dataKey] : {} })
      case 'date':
        return moment(row[column.dataKey].split(' ')[0]).format('MM/DD/YYYY')
      case 'select':
        return <StatusChanger
            currentStatus={row[column.dataKey]}
            options={column.options}
            isReadOnly={selectedRow.status === 'accepted' || column.isReadOnly}
            onSelectStatus={column.isReadOnly ? null : column.onSelect.bind(null, row)}
            key={column.key}
            dataKey={column.dataKey}
            minWidth={column.minWidth}
            disabled={column.disabled}
            colorless={column.colorless}
            selectedRow={selectedRow}
        />
      case 'id':
        return '...' + row.UUID.slice(-4)
      case 'dashed-link':
        return <DashedLink name={column.label ? column.label : row[column.dataKey]} />
      case 'default-link':
        if (column.isConditional) {
          return row[column.dataKey] ? <DefaultLink /> : null
        } else {
          return <DefaultLink />
        }
      case 'delete':
        return <IconTrashCan onClick={(e) => {
          e.stopPropagation()
          actions.delete(row)
        }} />
      case 'edit':
        return <IconEdit onClick={() => actions[column.dataKey](row)} />
      case 'text-prefix':
        return column.prefix + row[column.dataKey]
      case 'text-postfix':
        const amount = row[column.dataKey]
        return amount + ' ' + ((amount === 0 || amount > 1) ? column.postfix + 's' : column.postfix)
      case 'blank':
        return <span className="table__empty-cell"></span>
      case '--':
        return <span className="table__empty-cell table__empty-cell--dash-dash">--</span>
      case 'number':
        return <span className='table__dollar' style={column.cellPadding ? { padding: column.cellPadding } : {}}>{row[column.dataKey] ? row[column.dataKey].toFixed(2) : null}</span>
      case 'text':
      case 'notes':
      default:
        return <span className='table_capitalize' style={column.cellPadding ? { padding: column.cellPadding } : {}}>{_.get(row, column.dataKey)}</span>
    }
  }, [checkedRows, selectedRow]);

  /**
   * Get row identity
   *
   * @param {Object} row
   *
   * @returns {string}
   */

  const getRowId = (row) => {
    return keyProp ? row[keyProp] : row.UUID

  }
  const rowOnClick = (row) => {
    const rowId = getRowId(row);
    setSelectedRow(row);
    setOpen({ ...open, [rowId]: !open[rowId] })
  }


  const checkboxOnClick = (row) => {
    const rowId = getRowId(row)
    let newRows = { ...checkedRows }
    if (!checkedRows[rowId]) {
      setCheckedRows({ ...newRows, [rowId]: true })
    } else {
      delete newRows[rowId]
      setCheckedRows(newRows)
    }
  }

  const specificPadding = () => {
    return padding ? { paddingLeft: padding } : {}
  }
  const isModalOpened = getCheckboxIds(checkedRows).length > 0

  /**
   * Get Selected order
   *
   * @param {Object} row
   *
   * @returns {string}
   */
  const getRenderData = useMemo(() => {
    let newData = data
    if (show === false) {
      if (countingMode === 'Bin') {
        newData = data.filter(data => data.unitPrice >= value)
      } else {
        //newData = data.filter(data => data.status === 'active')
        newData = data.filter(data => data.unitPrice >= value)
      }
    }
    if (filterType !== 'selected') {
      return newData
    }


    return newData.filter(row => Object.keys(checkedRows).includes(row.partnum))
  }, [ filterType, data, show, checkedRows, value ])

  const acceptHundler = (rows) => {
    const checkedFormattedRows = {...checkedRows};
    rows.forEach(el => {
      delete checkedFormattedRows[el];
    })

    setCheckedRows({...checkedFormattedRows});
  };

  return (

    <div className="table__body">
      {isModalOpened && countingMode === 'Parts' && (
        <ModalOrderInfo
            order={order}
            data={data}
            checkedRows={checkedRows}
            setFilterType={setFilterType}
            filterType={filterType}
            acceptHundler={acceptHundler}
        />
      )}
      <ul className="table__body-list">

        {getRenderData.map(row => (
          <li className={Object.keys(checkedRows).includes(row.partnum) ? 'border' : ''} key={getRowId(row)}>
            <div
              className={row.status === 'accepted' ? 'table__row__blue table__row--clickable' : 'table__row--clickable table__row'}
              onClick={() => rowOnClick(row)}
            >
              <FoldIndicator isOpen={open[getRowId(row)]} />
              <ul
                className="table__row-list"
                style={specificPadding()}
                key={`${getRowId(row)}-1`}
              >
                {options.columns.map(column => (
                  <li
                    className={
                      column.flexGrow
                        ? `${column.flexGrow} table__row-item table__row-item--${column.type}`
                        : `table__row-item table__row-item--${column.type}`
                    }
                    title={column.type === 'notes' ? row.notes : ''}
                    key={`${getRowId(row)}${column.name}`}
                  >
                    {cellGenerator(column, row, open[getRowId(row)])}
                  </li>
                ))}
              </ul>
            </div>
            {
              open[getRowId(row)] &&
              <ul className="table__body-list table__body-list--children">
                {row[options.childrenKey] && row[options.childrenKey].map(row => (
                  <li
                    className="table__row--clickable table__row table__row--children"
                    key={row.id}
                  >
                    <ul
                      className="table__row-list"
                      style={specificPadding()}
                    >
                      {options.childrenColumns.map(column => (
                        <li
                          className={
                            column.flexGrow
                              ? `${column.flexGrow} table__row-item table__row-item--${column.type}`
                              : `table__row-item table__row-item--${column.type}`
                          }
                          title={column.type === 'notes' ? row.notes : ''}
                          key={`${getRowId(row)}${column.name}`}
                        >
                          {cellGenerator(column, row, open[getRowId(row)])}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            }
          </li>
        ))}
        <VarianceTitle hidden={true} />
      </ul>
    </div>
  )

}


const mapStateToProps = ({ data: { show, render, value } }) => ({ show, render, value })
const mapDispatchToProps = ({ getValue, rerender })


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TableBody))
